export const theme = {
	colors: {
		text: "#433D60",
		textSecondary: "#000",
		hoverText: "#ff0000b0",
		bgColor1: "#faf9f7",
		bgColor2: "#7e7e7e",
		white: "white",
		light: "#818181",
	},
	shadow: "0px 0px 28px 0px #828282",
	imgShadow: "5px 5px 5px 0px rgba(0, 0, 0, 0.75)",
	radii: ["3px", "80px", "50%"],
	breakpoints: [
		"320px",
		"420px",
		"520px",
		"620px",
		"720px",
		"820px",
		"920px",
		"1020px",
		"1080px",
	],
	fonts: {
		body: '"Roboto", sans-serif',
		heading: '"Montserrat", sans-serif',
	},
	fontWeights: {
		regular: 400,
		medium: 500,
		SemiBold: 600,
		bold: 700,
		extraBold: 800,
		black: 900,
	},
	fontSizes: {
		fs9: "9px",
		fs10: "10px",
		fs11: "11px",
		fs12: "12px",
		fs13: "13px",
		fs14: "14px",
		fs15: "15px",
		fs16: "16px",
		fs17: "17px",
		fs18: "18px",
		fs19: "19px",
		fs20: "20px",
		fs21: "21px",
		fs22: "22px",
		fs23: "23px",
		fs24: "24px",
		fs25: "25px",
		fs26: "26px",
		fs27: "27px",
		fs28: "28px",
		fs30: "30px",
		fs31: "31px",
		fs36: "36px",
		fs38: "38px",
		fs60: "60px",
	},

	lineHeights: {
		lh10: "1",
		lh11: "1.1",
		lh12: "1.2",
		lh13: "1.3",
		lh14: "1.4",
		lh15: "1.5",
		lh16: "1.6",
		lh17: "1.7",
		lh18: "1.8",
		lh19: "1.9",
		lh20: "2",
		lh21: "2.1",
		lh22: "2.2",
		lh23: "2.3",
	},
};
